<template>

    <div class="container-fluid p-0">
        <div class="row m-0" v-if="!is_expired">
            <div class="col-12 p-0">
                <div class=" login-card  card login-dark">
                    <div  >
                        <div class="card-header"  >
                            <h4>Vehicle Details </h4>
                            <span v-if="request.approval_status==0" class="badge badge-pill badge-warning text-white">
                                                                    {{getStatusText(request.approval_status)}}
                                                            </span>
                                                            <span v-else-if="request.approval_status<=4" class="badge badge-pill badge-success text-white">
                                                                    {{getStatusText(request.approval_status)}}
                                                            </span>
                                                            <span v-else-if="request.approval_status>4" class="badge badge-pill badge-danger text-white">
                                                                     {{getStatusText(request.approval_status)}}
                                                            </span>
                        </div>

                        <div class="card-body bg-white">
 
                            <div class="col-12 row">
                                <div class="col-12 "> 
                                    <canvas ref="qrcodeCanvas"></canvas>
                                </div>
                                <div class="col-12 ">
                                        <b>Code:</b>  {{ request.empcode }}<br> 
                                        <b>Name:</b>  {{ request.empname }}<br>
                                        <b>Phone No.:</b>  {{ request.contact }}<br>
                                        <b>Department:</b>  {{ request.dept_name }}<br> 
                                </div>
                                 
                            </div> 
                            <table class="table">
                                    <tr class="bottomborder">
                                        <td><b>Purpose</b></td>
                                        <td>{{ request.purpose }}</td>
                                    </tr>
                                    <tr class="bottomborder">
                                        <td><b>Source</b></td>
                                        <td>{{ request.source }}</td>
                                    </tr>
                                    <tr   class="bottomborder">
                                        <td><b>Destination</b></td>
                                        <td>{{ request.destination }}</td>
                                    </tr> 
                                    <tr   class="bottomborder">
                                        <td><b>Check Out</b></td>
                                        <td>{{ request.schedule_checkout_date + '   -  '+request.schedule_checkout_time }}</td>
                                    </tr> 
                                    <tr   class="bottomborder">
                                        <td><b>Check In</b></td>
                                        <td>{{ request.schedule_checkin_date + '   -  '+request.schedule_checkin_time }}</td>
                                    </tr> 
                                    
                                     <tr  v-if="request.checkout_date!=null" class="bottomborder bg-success-light">
                                        <td><b>Actual Check Out</b></td>
                                        <td>{{ request.checkout_date}}</td>
                                    </tr> 
                                     <tr  v-if="request.checkin_date!=null" class="bottomborder bg-danger-light">
                                        <td><b>Actual Check In</b></td>
                                        <td>{{ request.checkin_date }}</td>
                                    </tr> 
                                </table>
                               
                        </div>
                        <div class="card-footer bg-white" >
                                                            <div v-if="scan_user?.empdept == sd && request.checkout_date == null && request.approval_status == 3">
                                                                <button title="Mark Check In" class="btn btn-primary"
                                                                  @click="mark_checkin(request.token, 2)">Check Out </button>
                                                            </div>
                                                            
                                                             <div
                                                                v-if="scan_user?.empdept == sd && request.checkout_date != null && request.checkin_date == null  ">
                                                                <button title="Mark Checkout" class="btn btn-primary"
                                                                    @click="mark_checkin(request.token, 1)">Check
                                                                    In</button>
                                                            </div>
                                                            
                                                            
                        </div> 
                    </div>
                    
                </div>
            </div>
        </div>
    </div>





</template>
<style scoped>
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
.avatar img{
    width: 100%; 
}
.login-card {
    min-height: 80vh;
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";
import QRCode from 'qrcode';

export default {
    name: 'VehicleRequestView',
    components: {

    },
    mounted() {
        if (this.$route.query.q) {
                this.getBasics(this.$route.query.q);
            }else
            window.location.href = this.$cur_host+'login';
    },
    data() {
        return {  
            scan_user:[],
            sd:0,
            request: { "empname": '', "empname": '',"contact": '', "purpose": '','dept_name':'','source':'','destination':'','schedule_checkout_date':'','schedule_checkout_time':'','schedule_checkin_date':'','schedule_checkin_time':'','approval_status':'' },
            status:'',
            is_expired:false
        }
    },
    methods: {  
         getStatusText(status) {
               
                const statusNum = Number(status);
                
                switch(statusNum) {
                    case 0: return 'Pending';
                    case 1: return 'HOD Approved Pending For HR';
                    case 2: return 'HR Approved  Pending For Security';
                    case 3: return 'Security Approved';
                    case 4: return 'HOD Declined';
                    case 5: return 'HR Declined';
                    case 6: return 'Security Declined';
                    case 7: return 'On Hold';
                    default: return 'Unknown Status (' + status + ')'; // Show the actual value for debugging
                }
            },
        getBasics(token) {
            var self = this;
            axios.post('getvehicalrequest',{token:token}).then(function (response) {
                self.request= response.data.request;
                self.sd= response.data.sd;
                self.scan_user= response.data.scan_user;
                   if(self.request){
                           self.getQrCode(self.request.token);
                   }else{
                       self.is_expired=true;
                       self.$swal("Sorry Page Expired");
                       
                   }
                window.scrollTo(0, 0);
            });
        },
        async getQrCode(token) {
            try {
              if(token.length>0){
                  const canvas = this.$refs.qrcodeCanvas;
                 var url=this.$api_host+'vehiclepassview?q='+token;
                   //var url='http://192.168.1.8:8081/vehiclepassview?q='+token;
                  await QRCode.toCanvas(canvas,url , { width: 200 });
                  $("#qrcodeView").modal("toggle");
              }
              
            } catch (error) {
              console.error(error);
            }
          },
             mark_checkin(passid,what) {
            var self = this;
            self.$swal({
                title: "Do You Want To proceed ?",
                text: "Just For Confirmation !",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes"
            }).then((result) => { // <--
                if (result.value) { // <-- if confirmed
                
                    
            
                    const formData = new FormData();
                     
                    formData.append('passid', passid);
                    formData.append('what', what);
                    
                    axios.post('qrVehiclecheckInUser', formData).then(function (response) {
                        if(response.data.is==1){
                            self.request = response.data.request;
                        }
                            self.$swal(response.data.gatepassReq);
                    }).then(() => {
                        });
                }
            });

        },

}
}
</script>
